import DescriptionIcon from "@mui/icons-material/Description";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";
import { FileMetadata } from "components/Products/ProductManager/ProductForm/ProductFormRewrite/ProductForm.schema";

interface FileCardProps {
  file: File;
  title?: string;
  subheader?: string;
  fileName?: string;
  index: number;
}

// TODO: CONSOLIDATE WITH ECR FILE CARD

const FileCard = ({
  file,
  index,
  title,
  subheader,
  fileName,
}: FileCardProps) => {
  const field = useFieldContext<FileMetadata[]>();

  const handleRemove = () => {
    console.log("field.state.value", field.state.value[index]);
    // TODO: we may not even need removeValue here if we are going to use active...idk tho
    if (field.state.value[index].file_id) {
      field.setValue(
        field.state.value.map((file, i) =>
          i === index ? { ...file, active: false } : file,
        ),
      );
    } else {
      field.removeValue(index);
    }
  };

  return (
    <Card sx={{ maxWidth: "175px", display: "flex", flexDirection: "column" }}>
      <CardHeader
        title={title || file.name}
        sx={{
          background: "whitesmoke",
          flexDirection: "row-reverse",
          ".MuiCardHeader-avatar": {
            height: "100%",
            margin: 0,
          },
        }}
        subheader={subheader}
        avatar={
          <DescriptionIcon
            sx={{
              alignSelf: "flex-start",
            }}
            fontSize="small"
          />
        }
        slotProps={{
          title: {
            fontSize: 18,
          },
          subheader: {
            fontSize: 14,
          },
        }}
      />
      <Box></Box>

      <CardContent
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",

          padding: 1,
          "&.MuiCardContent-root:last-child": {
            paddingBottom: 1,
          },
        }}
      >
        <Box flex={1}>
          <Typography
            fontSize={16}
            paddingX={1}
            sx={{
              wordBreak: "break-word",
              overflowWrap: "anywhere",
            }}
            align="center"
          >
            {fileName}
          </Typography>
        </Box>
      </CardContent>

      <CardActions sx={{ justifyContent: "flex-end" }}>
        {/* TODO: add remove button logic here */}
        <Button
          variant="outlined"
          color="error"
          fullWidth
          size="small"
          onClick={handleRemove}
        >
          Remove
        </Button>
      </CardActions>
    </Card>
  );
};
export default FileCard;
